export default __webpack_public_path__ + "static/media/import.acdab879.svg";